import { render, staticRenderFns } from "./AssignParentToOrg.vue?vue&type=template&id=5a7a3ae4&scoped=true"
import script from "./AssignParentToOrg.vue?vue&type=script&lang=js"
export * from "./AssignParentToOrg.vue?vue&type=script&lang=js"
import style0 from "./AssignParentToOrg.vue?vue&type=style&index=0&id=5a7a3ae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7a3ae4",
  null
  
)

export default component.exports